export { default } from './TherapeuticCategoryRouter';
